type CustomTickProps = {
  x?: number;
  y?: number;
  payload?: {
    value: string | number;
  };
  rectFill?: string;
  rectWidth?: number;
  rectHeight?: number;
  rectX?: number;
  rectY?: number;
  rectRadius?: number;
};

const CustomTickWithBackground = (props: CustomTickProps) => {
  const {
    x,
    y,
    payload,
    rectWidth = 40,
    rectHeight = 20,
    rectX = -20,
    rectY = 0,
    rectRadius = 4,
    rectFill = '#F0EEED',
  } = props;
  const label = payload?.value;

  return (
    <g transform={`translate(${x}, ${y})`}>
      <rect
        x={rectX}
        y={rectY}
        width={rectWidth}
        height={rectHeight}
        fill={rectFill}
        rx={rectRadius}
      />
      <text
        x={0}
        y={15}
        textAnchor="middle"
        fill="#F0EEED"
        fontSize="0"
        fontWeight={400}
        letterSpacing="-0.01em"
      >
        {label}
      </text>
    </g>
  );
};

export default CustomTickWithBackground;
